import React from "react";
import { Link } from "react-router-dom";
import { FaHeart, FaArrowLeft, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const MembershipPage = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/login");
  };
  const plans = [
    {
      name: "Gold",
      price: "₹999",
      duration: "3 Months",
      features: [
        "Send unlimited messages",
        "View up to 50 contact numbers",
        "Stand out with bold listing",
        "Priority customer support",
      ],
      recommended: false,
    },
    {
      name: "Diamond",
      price: "₹1,999",
      duration: "6 Months",
      features: [
        "Send unlimited messages",
        "View up to 150 contact numbers",
        "Stand out with bold listing",
        "Priority customer support",
        "Profile Highlighter",
      ],
      recommended: true,
    },
    {
      name: "Platinum",
      price: "₹2,999",
      duration: "12 Months",
      features: [
        "Send unlimited messages",
        "View up to 300 contact numbers",
        "Stand out with bold listing",
        "Priority customer support",
        "Profile Highlighter",
        "Relationship Manager",
      ],
      recommended: false,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm py-4 sticky top-0 z-50">
        <div className="container mx-auto px-6 flex justify-between items-center">
          <Link to="/">
            <img
              src="/logo1.png" // replace with your actual logo path
              alt="MatchZone Logo"
              className="h-14 w-36 rounded-xl"
            />
          </Link>

          <Link
            to="/"
            className="flex items-center text-gray-600 hover:text-rose-600 font-medium"
          >
            <FaArrowLeft className="mr-2" /> Back to Home
          </Link>
        </div>
      </nav>

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl font-black text-gray-900 mb-4">
            Upgrade to <span className="text-rose-600">Premium</span>
          </h1>
          <p className="text-lg text-gray-600">
            Choose a plan that suits your needs and speed up your partner
            search.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-8 border transition-all duration-300 ${
                plan.recommended
                  ? "border-rose-500 shadow-2xl scale-105 relative z-10"
                  : "border-gray-200 shadow-lg hover:shadow-xl"
              }`}
            >
              {plan.recommended && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-rose-600 text-white px-4 py-1 rounded-full text-sm font-bold shadow-lg">
                  Recommended
                </div>
              )}
              <div className="text-center mb-8">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  {plan.name}
                </h3>
                <div className="text-4xl font-black text-gray-900 mb-1">
                  {plan.price}
                </div>
                <div className="text-gray-500">{plan.duration}</div>
              </div>
              <ul className="space-y-4 mb-8">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-start text-gray-600">
                    <FaCheck className="text-green-500 mt-1 mr-3 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={handleClick}
                className={`w-full py-3 rounded-xl font-bold transition-all ${
                  plan.recommended
                    ? "bg-rose-600 text-white hover:bg-rose-700 shadow-lg shadow-rose-500/30"
                    : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                }`}
              >
                Choose {plan.name}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MembershipPage;
